import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import { fill_action } from '../../../../../actions/fillCombo_action';
import { cityActionId, stallTypeActionId, stallListActionId, countryActionId, exhibitionActionId, toastError, toastSuccess } from "../../../../../utils/constants";
import { emailValidator } from "../../../../../utils/Validator";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "react-modal";
import moment from "moment";
import Pagination from "../../../../../utils/pagination";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import { useNavigate } from "react-router-dom";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import { deleteHallMaster_action } from "../../../../../actions/admin_module_action/master_action/hall_master_action";
import { getLiquorLicenseMasterList_action, insertUpdateLiquorLicenseMaster_action, deleteLiquorLicenseMaster_action } from "../../../../../actions/admin_module_action/master_action/manual_form_master_action/liquor_license_master_action";
import Footer from "../../../../../common_components/Footer";


class LiquorLicenseMaster extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            // currentPage: 1,
            LLList: [{
                'Name': '',
                'Address': '',
                'Phone': '',
                "Mobile": '',
                'Fax': '',
                'PrimaryEmail': '',
                'SecondaryEmail': '',
                'isNew': true,
            }],
            deleteID: '',
            editingIndex: null,
            editingBackup: null,
        }

        this.record = this.record.bind(this)
        this.onInput = this.onInput.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleAdd = this.handleAdd.bind(this)
        this.deleteLiquorLicenseMaster = this.deleteLiquorLicenseMaster.bind(this)
        this.onDelete = this.onDelete.bind(this)
        this.getLiquorlicenseMasterList = this.getLiquorlicenseMasterList.bind(this)
        this.handleEditRow = this.handleEditRow.bind(this)
        this.handleCancelEdit = this.handleCancelEdit.bind(this)
    }

    componentDidMount() {
        this.getLiquorlicenseMasterList(null)
    }

    handleEditRow(i) {
        const { LLList } = this.state
        this.setState({ editingIndex: i, editingBackup: { ...LLList[i] } })
    }

    handleCancelEdit(i) {
        const { LLList, editingBackup } = this.state
        LLList[i] = editingBackup
        this.setState({ LLList: [...LLList], editingIndex: null, editingBackup: null })
    }

    onInput(value, i, flag) {
        const { LLList } = this.state
        console.log(value, i, flag)
        if (flag == 'Name') {
            LLList[i].Name = value
        } else if (flag == 'Address') {
            LLList[i].Address = value
        } else if (flag == 'Mobile') {
            LLList[i].Mobile = value
        } else if (flag == 'Telephone') {
            LLList[i].Phone = value
        } else if (flag == 'Fax') {
            LLList[i].Fax = value
        } else if (flag == 'PrimaryEmail') {
            LLList[i].PrimaryEmail = value
        } else if (flag == 'SecondaryEmail') {
            LLList[i].SecondaryEmail = value
        }
        this.setState({ LLList: LLList })
    }

    record(list) {
        const { editingIndex } = this.state
        const isEditing = (i) => list[i].isNew || editingIndex === i

        return (
            <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                <thead>
                    <tr>
                        <th className="text-center" style={{ width: '50px' }}>Sr no.</th>
                        <th className="text-center">Name<span className="text-red">*</span></th>
                        <th className="text-center">Address</th>
                        <th className="text-center">Mobile No.<span className="text-red">*</span></th>
                        <th className="text-center">Telephone</th>
                        <th className="text-center">Fax</th>
                        <th className="text-center">Primary Email<span className="text-red">*</span></th>
                        <th className="text-center">Secondary Email</th>
                        <th className="text-center" style={{ width: '100px' }}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {list.length > 0 ? list.map((data, i) => (
                        <tr key={i} style={isEditing(i) ? { backgroundColor: '#f0f7ff' } : {}}>
                            <td className="text-center align-middle" style={{ width: '50px' }}>{i + 1}</td>
                            {isEditing(i) ? (
                                <>
                                    <td><input type="text" className="form-control" value={data.Name} onChange={(e) => this.onInput(e.target.value, i, 'Name')} /></td>
                                    <td><input type="text" className="form-control" value={data.Address} onChange={(e) => this.onInput(e.target.value, i, 'Address')} /></td>
                                    <td><input type="text" className="form-control" placeholder="Use / to separate multiple numbers" value={data.Mobile} onChange={(e) => this.onInput(e.target.value, i, 'Mobile')} /></td>
                                    <td><input type="text" className="form-control" placeholder="Use / to separate multiple numbers" value={data.Phone} onChange={(e) => this.onInput(e.target.value, i, 'Telephone')} /></td>
                                    <td><input type="text" className="form-control" placeholder="Use / to separate multiple numbers" value={data.Fax} onChange={(e) => this.onInput(e.target.value, i, 'Fax')} /></td>
                                    <td><input type="text" className="form-control" value={data.PrimaryEmail} onChange={(e) => this.onInput(e.target.value, i, 'PrimaryEmail')} /></td>
                                    <td><input type="text" className="form-control" value={data.SecondaryEmail} onChange={(e) => this.onInput(e.target.value, i, 'SecondaryEmail')} /></td>
                                    <td className="text-center align-middle">
                                        {!data.isNew && (
                                            <button type="button" className="btn btn-outline-secondary btn-sm border-0" title="Cancel" onClick={() => this.handleCancelEdit(i)}>
                                                <i className="fa fa-times" />
                                            </button>
                                        )}
                                        <button type="button" className="btn btn-outline-danger btn-sm border-0" title="Delete" onClick={() => this.onDelete(data.LiquorLicenseContactPersonID, i, data.isNew)}>
                                            <i className="fa fa-trash action_btn_table" />
                                        </button>
                                    </td>
                                </>
                            ) : (
                                <>
                                    <td className="text-center align-middle">{data.Name}</td>
                                    <td className="text-center align-middle">{data.Address}</td>
                                    <td className="text-center align-middle">{data.Mobile}</td>
                                    <td className="text-center align-middle">{data.Phone}</td>
                                    <td className="text-center align-middle">{data.Fax}</td>
                                    <td className="text-center align-middle">{data.PrimaryEmail}</td>
                                    <td className="text-center align-middle">{data.SecondaryEmail}</td>
                                    <td className="text-center align-middle">
                                        <button type="button" className="btn btn-outline-primary btn-sm border-0" title="Edit" onClick={() => this.handleEditRow(i)}>
                                            <i className="fa fa-pencil action_btn_table" />
                                        </button>
                                        <button type="button" className="btn btn-outline-danger btn-sm border-0" title="Delete" onClick={() => this.onDelete(data.LiquorLicenseContactPersonID, i, data.isNew)}>
                                            <i className="fa fa-trash action_btn_table" />
                                        </button>
                                    </td>
                                </>
                            )}
                        </tr>
                    )) : (
                        <tr><td colSpan={9} className="text-center">No records found</td></tr>
                    )}
                </tbody>
            </table>
        )
    }

    getLiquorlicenseMasterList(keepUnsaved) {
        this.setState({ isLoading: true })
        const { LLList } = this.state
        const unsavedRows = keepUnsaved ? LLList.filter(item => item.isNew) : []
        this.props.getLiquorLicenseMasterList_action()
            .then((data) => {
                if (data.error != 1) {
                    const savedData = (data.data || []).map(item => ({ ...item, isNew: false }))
                    this.setState({ LLList: [...savedData, ...unsavedRows], isLoading: false })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
                this.setState({ isLoading: false })
            })
    }

    handleAdd() {
        const { LLList } = this.state
        console.log("pp")
        var obj = {
            'Name': '',
            'Address': '',
            'Phone': '',
            "Mobile": '',
            'Fax': '',
            'PrimaryEmail': '',
            'SecondaryEmail': '',
            'isNew': true
        }
        LLList.push(obj)
        this.setState({ LLList: LLList })
    }

    handleSubmit() {
        const { LLList } = this.state
        var arr = [...LLList]
        var err = false
        for (var i = 0; i < arr.length; i++) {
            if (arr[i].Name == '' || arr[i].Name == null) {
                err = 'Please enter mandatory fields'
                break
            }
            if (arr[i].Mobile == '' || arr[i].Mobile == null) {
                err = 'Please enter mandatory fields'
                break
            }
            if (arr[i].PrimaryEmail == '' || arr[i].PrimaryEmail == null) {
                err = 'Please enter mandatory fields'
                break
            } else {
                err = (emailValidator(arr[i].PrimaryEmail) == '') ? false : emailValidator(arr[i].PrimaryEmail)
                if (err) {
                    break
                }
            }
            if (arr[i].SecondaryEmail != '' && arr[i].SecondaryEmail != null) {
                err = (emailValidator(arr[i].SecondaryEmail) == '') ? false : emailValidator(arr[i].SecondaryEmail)
                if (err) {
                    break
                }
            }
        }
        if (!err) {
            this.setState({ isLoading: true })
            this.props.insertUpdateLiquorLicenseMaster_action(arr)
                .then((data) => {
                    if (data == null) {
                        this.setState({ isLoading: false })
                        toastError('Something went wrong!')
                        return
                    }
                    if (data.error != 1) {
                        toastSuccess('Saved successfully.')
                        this.getLiquorlicenseMasterList(false)
                        this.setState({ isLoading: false, editingIndex: null, editingBackup: null })
                    }
                    else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                    this.setState({ isLoading: false })
                    toastError('Something went wrong!')
                })
        } else {
            toastError(err)
        }
    }

    deleteLiquorLicenseMaster(id) {
        this.setState({ isLoading: true })
        this.props.deleteLiquorLicenseMaster_action(id)
            .then((data) => {
                if (data.error != 1) {
                    console.log(data.data)
                    this.setState({ isLoading: false })
                    toastSuccess("deleted successfully")
                    setTimeout(() => {
                        this.getLiquorlicenseMasterList(1)
                    }, 200);
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
                this.setState({ isOpen: false })
            })
            .catch((err) => {
                console.log(err)
            })
    }


    onDelete(id, index, status) {
        const { LLList } = this.state
        console.log(status, index)
        if (status) {
            LLList.splice(index, 1)
            this.setState({ LLList: LLList })
        } else {
            this.setState({ deleteID: id })
            this.setState({ isOpen: true, })
        }
    }


    render() {
        const { isOpen, isLoading, LLList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                <>
                    <div className="app-content with-dr-container com-height">
                        <AdminDrawer />
                        <div className="main-container">
                            <div className="row m-0">
                                <div className="breadcrumb-scroll-fixed">
                                    <h6 className="mb-0 p-2 text-white">Liquor License Master</h6>
                                </div>
                            </div>
                            <div className="admin-top-space p-2 px-0">
                                <div className="row m-0">
                                <div className="table-responsive">
                                    <div
                                        className="card-header p-2"
                                        style={{ paddingLeft: "7px !important" }}
                                    >
                                        <h3 className="card-title" style={{ fontSize: 15 }}>
                                            Agency contact details
                                        </h3>
                                    </div>
                                    {this.record(LLList)}
                                </div>
                                </div>
                            </div>
                            <div className="text-end px-2">
                                <button type="button" class="btn btn-aqua" onClick={this.handleAdd}>
                                    Add Row
                                </button>
                                <button type="button" className="btn btn-aqua ms-2" data-dismiss="modal"
                                    onClick={this.handleSubmit} disabled={LLList.length == 0}>
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </>
                <Modal isOpen={isOpen} onRequestClose={() => this.setState({ isOpen: false })}>
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div class="modal-header text-right p-2">
                                <h5 class="modal-title">Do you really want to delete this record?</h5>

                                {/* <button type="button " class="close pop-close" data-dismiss="modal"
                                    onClick={() => this.setState({ isOpen: false })}
                                ><span aria-hidden="true" class="pop-cancel">&times;</span></button> */}
                            </div>
                            {/* <div class="modal-body">
                                <div class="row">
                                </div>
                            </div> */}
                            <div class="modal-footer p-2">
                                <div class="form-group text-right mod-fot">
                                    <button type="button" class="btn btn-del-pop"
                                        onClick={(e) => this.deleteLiquorLicenseMaster(this.state.deleteID)}
                                    >Yes</button>
                                    <button type="button" class="btn btn-gray" data-dismiss="modal" style={{ marginLeft: '5px' }}
                                        onClick={() => this.setState({ isOpen: false })}
                                    >No</button>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal>
                <Footer />
            </>)
    }

}
export default withRouter(connect(null, { fill_action, getLiquorLicenseMasterList_action, deleteLiquorLicenseMaster_action, insertUpdateLiquorLicenseMaster_action })(LiquorLicenseMaster));